class ImageWithThumbnails extends HTMLElement {
  constructor() {
    super()
    this.mainCarousel?.addEventListener("SLIDER_CHANGED", this.onSliderChanged.bind(this))

    this.thumbnailItems.forEach((item) => {
      item.addEventListener("click", this.onThumbnailClick.bind(this))
    })
  }

  onThumbnailClick(event) {
    const index = parseInt(event.currentTarget?.getAttribute("data-index") || "0")
    this.mainCarousel.moveToIndex(index, false)
    this.activeThumbnail(index)
  }
  

  onSliderChanged(event) {
    if (event.detail && event.detail.key == "sliderIndex") {
      const changedSliderIndex = event?.detail?.value || 0
      this.activeThumbnail(changedSliderIndex)
      this.thumbnailCarousel?.moveToIndex(changedSliderIndex)
    }
  }

  activeThumbnail(index) {
    this.thumbnailItems.forEach((thumbnail) => {
      const thumbnailIndex = parseInt(thumbnail.getAttribute("data-index") || "0")
      if (thumbnailIndex == index) {
        thumbnail.classList.add("active")
      } else {
        thumbnail.classList.remove("active")
      }
    })
  }

  get carousels() {
    return this.querySelectorAll(".js-images-main, .js-images-thumbnails")
  }

  get mainCarousel() {
    return this.querySelector(".js-images-main")
  }

  get thumbnailCarousel() {
    return this.querySelector(".js-images-thumbnails")
  }

  get thumbnailItems() {
    return this.querySelectorAll(".js-images-thumbnails .js-media-item")
  }
}

customElements.define("image-with-thumbnails", ImageWithThumbnails)
